import React from "react"

import Layout from "../components/layout"
import Head from '../components/head'
import indexStyle from './index.module.scss'

import Hero from '../components/hero'
import Oferta from '../components/oferta'
import Contact from '../components/contact'
import Portfolio from '../components/portfolio'

export default function Home() {
  return (
    <Layout>
      <Head title="Home" />

      
      <Hero></Hero>
      <Oferta></Oferta>
      <Portfolio></Portfolio>

    <Contact></Contact>
    </Layout>
  )
}
